<template>

    <base-nav class="navbar-top navbar-dark"
              id="navbar-main"
              :show-toggle-button="false"
              expand>
        <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <div class="form-group mb-0">

            </div>
        </form>
        <a-drawer title="" width="650" placement="right" @close="onClose" :visible="showDrawer">
                <h6 class="heading-small text-muted mb-4">Account Settings</h6>  
                 <base-alert v-if="errors.length" type="danger">
                    <b>You have the following error(s):</b>
                    <li v-for="error in errors" :key="error">{{ error }}</li>
                </base-alert>
                <form>
                    <a-tabs defaultActiveKey="1" type="card">
                      <a-tab-pane tab="Global" key="1">
                            <a-tabs defaultActiveKey="1" tab-position="left">
                              <a-tab-pane tab="Inventory Documents" key="1" class="mb-2 mr-2">
                                <base-input label="Costing Method" size="lg" required>
                                    <select class="form-control form-control-sm" input-classes="form-control" v-model="accountCredentials.documentCostingMethod">
                                        <option v-for="option in costingMethodOptions" v-bind:value="option.key" :key="option.key">
                                            {{ option.value }}
                                        </option>
                                    </select>
                                </base-input>
                                <base-checkbox class="mb-3" v-model="accountCredentials.enableInventorySnapshot"
                                        >Enable Inventory Snapshot</base-checkbox>
                              </a-tab-pane>
                              <a-tab-pane tab="Currency" key="2" class="mb-2 mr-2">
                                <base-input label="Default Currency" size="lg" required>
                                    <select class="form-control form-control-sm" input-classes="form-control" v-model="accountCredentials.defaultCurrency" @change="testing">
                                        <option value="0" key="Currency0">PHP</option>
                                        <option v-for="option in currenciesOptions" v-bind:value="option.id" :key="'Currency'+option.id">
                                            {{ option.name }}
                                        </option>
                                    </select>
                                </base-input>
                              </a-tab-pane>
                              <a-tab-pane tab="User" key="3" class="mb-2 mr-2">
                                <base-checkbox class="mb-3" v-model="accountCredentials.userPasswordFormatStrict"
                                >Enable Password Format Strict</base-checkbox>
                                <div v-if="accountCredentials.userPasswordFormatStrict">
                                  <span class="mb-0 text-sm font-weight-bold text-gray">Password minimum length.</span><br>
                                  <small class="text-gray">Enforce a minimum length of characters</small><br>
                                  <div class="mb-2">
                                    <div class="form-group row mb-0">
                                      <div class="col-sm-5">
                                        <input size="sm" min="6" v-model="accountCredentials.minPasswordLength" max="128" type="number" class="form-control mt-1">
                                      </div>
                                      <label class="col-sm-5 pl-0 col-form-label">characters</label>
                                    </div>
                                    <small class="text-gray mb-2">Need to be between 6 and 128</small>
                                  </div>
                                  <div class="mb-2">
                                    <span class="mt-2 text-sm font-weight-bold text-gray">Password Strength</span><br>
                                    <base-checkbox v-model="accountCredentials.passwordReqOneUppercase" class="mt-1"><small>Require atleast one uppercase letter from the Latin alphabet (A-Z)</small></base-checkbox>
                                    <base-checkbox v-model="accountCredentials.passwordReqOneLowercase"><small>Require atleast one lowercase letter from the Latin alphabet (a-z)</small></base-checkbox>
                                    <base-checkbox v-model="accountCredentials.passwordReqOneNumber"><small>Require atleast one number</small></base-checkbox>
                                    <base-checkbox v-model="accountCredentials.passwordReqOneSpecialChar"><small>Require atleast one non-alphanumeric character (!@#$%^&*()_+-=[]{}|'")</small></base-checkbox>
                                  </div>
                                  <span class="mb-0 text-sm font-weight-bold text-gray">Other requirements</span>
                                  <base-checkbox v-model="accountCredentials.onPasswordExpiration" class="mt-1"><small>Turn on password expiration</small></base-checkbox>
                                  <select v-if="accountCredentials.onPasswordExpiration" class="form-control form-control-sm mb-1 mt-1 w-50" input-classes="form-control" v-model="accountCredentials.passExpDuration" :required="accountCredentials.onPasswordExpiration">
                                      <option v-for="option in passExpDurationOption" v-bind:value="option.key" :key="option.key">
                                          {{ option.value }}
                                      </option>
                                    </select>
                                  <base-checkbox v-model="accountCredentials.allowUserChangeOwnPassword" ><small>Allow users to change their own password</small></base-checkbox>
                                </div>
                              </a-tab-pane>
                              <a-tab-pane tab="Print Settings" key="4" class="mb-2 mr-2">
                                <p>Purchase to Payment module</p>
                                <base-input label="Increase font size" size="lg">
                                  <a-input-number style="width: 100%" :min="0" v-model='accountCredentials.printSettingsFontSizePTPM' placeholder='Increase font size by 0.1'/>
                                </base-input>
                                  <!-- <base-input label="Paper Size" size="lg" required>
                                    <select class="form-control form-control-sm" input-classes="form-control" v-model="accountCredentials.printSettingsPaperSizePTPM">
                                        <option v-for="option in paperSizeOptions" v-bind:value="option.value" :key="option.name">
                                            {{ option.name }}
                                        </option>
                                    </select>
                                </base-input> -->
                              </a-tab-pane>
                              <a-tab-pane tab="Computation Settings" key="5" class="mb-2 mr-2">
                                <div class="mb-3">
                                  <label class="form-control-label">
                                    Apply 5.1 Computation
                                  </label>

                                  <div class="mt-2">
                                    <a-switch
                                      v-model="accountCredentials.apply_five_point_one_rounding"
                                    />
                                  </div>
                                </div>
                              </a-tab-pane>
                            </a-tabs>
                        </a-tab-pane>
                        <a-tab-pane tab="Payment Gateways" key="2">
                            <a-tabs defaultActiveKey="1" tab-position="left">
                              <a-tab-pane tab="Paymaya" key="1">
                                <base-input class= 'mb-0' alternative="" label="Key" v-model="accountCredentials.paymayaKey" type="password" input-classes="form-control"/>
                                <base-input class= 'mb-0' alternative="" label="Secret Key" v-model="accountCredentials.paymayaSecretKey" type="password" input-classes="form-control"/>
                              </a-tab-pane>
                              <a-tab-pane tab="Dragonpay" key="2">
                                <base-input class= 'mb-0' alternative="" v-model="accountCredentials.dragonPayUserName" label="Username" type="text" input-classes="form-control"/>
                                <base-input class= 'mb-0' alternative="" v-model="accountCredentials.dragonPayPassword" label="Password" type="password" input-classes="form-control"/>
                              </a-tab-pane>
                              <a-tab-pane tab="Ipay88" key="3">
                                <base-input class= 'mb-0' alternative="" v-model="accountCredentials.ipay88MerchantCode" label="Merchant Code" type="text" input-classes="form-control"/>
                                <base-input class= 'mb-0' alternative="" v-model="accountCredentials.ipay88MerchantKey" label="Merchant Key" type="text" input-classes="form-control"/>
                              </a-tab-pane>
                            </a-tabs>
                        </a-tab-pane>
                        <a-tab-pane tab="Logistics" key="3">
                            <a-tabs defaultActiveKey="1" tab-position="left">
                              <a-tab-pane tab="Mr.Speedy" key="1">
                                <base-input class= 'mb-0' alternative="" v-model="accountCredentials.mrSpeedyKey" label="Key" type="password" input-classes="form-control"/>
                              </a-tab-pane>
                            </a-tabs>
                        </a-tab-pane>

                    </a-tabs>
                    <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                        <button class="btn btn-success" @click.prevent="saveIntegCredentials">Save</button>
                        <button class="btn" @click.prevent="onClose">Cancel</button>
                    </div>
                </form>
        </a-drawer>

         <!-- <template slot="modal-header">
           ACCOUNT SETTINGS
         </template>
         <template slot="default" style="height: 100vh;">
           <br>
           <h3 class="heading-small text-muted"><span class="fa fa-info-circle text-blue"/> Please input your account credentials/keys for integrations below </h3>
           <br>
           <a-tabs defaultActiveKey="1" type="card">
                <a-tab-pane tab="Payment Gateways" key="1">
                    <a-tabs defaultActiveKey="1" tab-position="left">
                      <a-tab-pane tab="Paymaya" key="1">
                        <base-input class= 'mb-0' alternative="" label="Key" v-model="accountCredentials.paymayaKey" type="password" input-classes="form-control"/>
                      </a-tab-pane>
                      <a-tab-pane tab="Dragonpay" key="2">
                        <base-input class= 'mb-0' alternative="" v-model="accountCredentials.dragonPayUserName" label="Username" type="text" input-classes="form-control"/>
                        <base-input class= 'mb-0' alternative="" v-model="accountCredentials.dragonPayPassword" label="Password" type="password" input-classes="form-control"/>
                      </a-tab-pane>
                    </a-tabs>
                </a-tab-pane>
                <a-tab-pane tab="Logistics" key="2">
                    <a-tabs defaultActiveKey="1" tab-position="left">
                      <a-tab-pane tab="Mr.Speedy" key="1">
                        <base-input class= 'mb-0' alternative="" v-model="accountCredentials.mrSpeedyKey" label="Key" type="password" input-classes="form-control"/>
                      </a-tab-pane>
                    </a-tabs>
                </a-tab-pane>
            </a-tabs>
            <br><br><br><br>
         </template>
          <div slot="modal-footer" class="w-50">
            <b-button v-if="ownerAccount" variant="success" size="sm" class="float-right" @click="saveIntegCredentials"> Save </b-button>
        </div> -->

        <!-- <ul class="align-items-center d-none d-md-flex"> -->
            <!-- <li class="nav-item dropdown"> -->
                <base-dropdown class="pr-0 bg-white rounded" style="height: 64px;" position="left">
                    <div class="media align-items-center px-3 py-1" style="height: 64px;" slot="title">
                      <span class="avatar avatar-sm rounded-circle">
                        <img :src="accountLogo" alt="logobarter" />
                        </span>
                        <div class="media-body ml-2 d-none d-lg-block">
                            <span class="mb-0 text-sm font-weight-bold text-gray"><b>{{accountName}}</b> - {{userName}}</span><br>
                            <small class="text-gray" v-if="this.$parent.serverType == 'ho'">HO SERVER - {{branchName}} </small>
                            <small class="text-gray" v-else>BRANCH SERVER </small>
                        </div>
                    </div>

                    <template v-if='developerMode != true'>
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">User</h6>
                        </div>
                        <div v-if="restrictChangePassword" v-b-modal.modal-1 class="dropdown-item">
                            <i class="ni ni-lock-circle-open"></i>
                            <span>Change Password</span>
                        </div>
                        <div v-b-modal.modal-login-history class="dropdown-item">
                            <i class="fa fa-history"></i>
                            <span>Login History</span>
                        </div>
                        <!-- <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-calendar-grid-58"></i>
                            <span>Activities</span>
                        </router-link> -->
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Configurations</h6>
                        </div>
                        <div v-b-modal.modal-2 class="dropdown-item">
                            <i class="fa fa-wrench"></i>
                            <span>Configuration</span>
                        </div>
                        <div v-if="ownerAccount" class="dropdown-item" @click.prevent="openAccountSettings">
                            <i class="fa fa-cog"></i>
                            <span>Account Settings</span>
                        </div>
                        <div v-b-modal.modal-4 class="dropdown-item">
                            <i class="fa fa-cogs"></i>
                            <span>Privacy Settings</span>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div v-b-modal.modal-3 v-if="this.$parent.serverType == 'ho'" class="dropdown-item" @click="getSites">
                            <i class="fa fa-exchange-alt"></i>
                            <span>Switch Branch</span>
                        </div>
                        <div class="dropdown-item" @click.prevent="logout">
                            <i class="ni ni-user-run"></i>
                            <span id="logoutButton">Logout</span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="dropdown-item" @click.prevent="logout">
                            <i class="ni ni-user-run"></i>
                            <span id="logoutButton" >Logout</span>
                        </div>
                    </template>
                </base-dropdown>
            <!-- </li> -->
        <!-- </ul> -->
    </base-nav>
</template>

<script>
  import HTTPRequest from '../controllers/httpRequest.js'
  import secureStorage from '../controllers/secureStorage.js'
  import { mapState, mapActions } from 'vuex'
  import axios from "axios";

  var component_x, navigate;

  export default {
  mounted: async function(){
    component_x = this;
    navigate = this.$router;
    if (this.developerMode == true){
      this.userName = secureStorage.getItem("developerEmail")
      this.branchName =  "Developer"
      this.accountName = "Developer"
    }
    //Get Account Logo
    // let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
    //   if (logoSettings.length > 0 && logoSettings[0]["value"] != null)
    //     this.accountLogo = logoSettings[0]["value"]
    await this.getAccountSettings()
    if(this.accountCredentials.onPasswordExpiration!=undefined && this.accountCredentials.onPasswordExpiration && this.userPasswordExpiration!=undefined){
      if(this.dateToday > new Date(this.userPasswordExpiration)){
        console.log("Expired")
        this.$confirm({
          title:"Password Expired",
          content: "your password has been expired. Please Click 'OK' to change password...",
          onOk(){
             component_x.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
          }
        })
      }
    }
  },
  computed: {
    ...mapState(['loggedIn', 'endPoint', 'validSites', 'selectedSite']),
  },
    data() {
      return {
        accountLogo: secureStorage.getItem("account_logo"),
        activeNotifications: false,
        showMenu: false,
        searchQuery: '',
        userName: secureStorage.getItem("email"),
        userPasswordExpiration:secureStorage.getItem("passwordExpiration") || null,
        branchName: secureStorage.getItem("defaultSiteName"),
        accountName: secureStorage.getItem("accountName"),
        developerMode: secureStorage.getItem("developerMode"),
        configurationErrors: secureStorage.getItem("configurationErrorLogs"),
        showDrawer: false,
        accountCredentials: {},
        ownerAccount: secureStorage.getItem("isAccountOwner"),
        errors: [],
        costingMethodOptions: [
            {key: "FIFO", value: "FIFO"},
            {key: "LIFO", value: "LIFO"},
            {key: "AVERAGE", value: "Average"}
        ],
        passExpDurationOption: [
            {key: "1w", value: "One Week"},
            {key: "1m", value: "One Month"},
            {key: "2m", value: "Two Months"},
            {key: "3m", value: "Three Months"},
            {key: "6m", value: "Six Months"},
            {key: "1y", value: "1 Year"}
        ],
        currenciesOptions:[],
        businessTypeOptions:[],
        phpHasData:-1,
        restrictChangePassword:false,
        accountCredentialsCopy:{},
        dateToday:new Date(),
      };
    },
    watch: {
      selectedSite: function() {
          this.branchName = this.selectedSite
      },
      accountCredentials:function(){
        if(this.accountCredentials.documentCostingMethod !== undefined){
          this.errors = []
        }
      }
    },
    methods: {
    
      onClose(){
        this.accountCredentials.documentCostingMethod = undefined
        this.errors = []
        this.showDrawer = false;
      },

      checkSettings(settings){
          let requiredFields;
          if(settings !==null){
              requiredFields = JSON.parse(settings.value)
              if(requiredFields["documentCostingMethod"] === undefined){
                this.errors.push("Costing Method is required")
              }
          }else{
                this.errors.push("Costing Method is required")
          }
      },
      async getAccountSettings(){
        var credentials = await HTTPRequest.getRequest(this.endPoint + 'settings/accountSettings?field_name=code' , null)
        try {
          this.accountCredentials = JSON.parse(credentials.value)
          this.accountCredentialsCopy = this.accountCredentials
        } catch (error) {}
        if (this.accountCredentials.allowUserChangeOwnPassword != undefined) this.restrictChangePassword = this.accountCredentials.allowUserChangeOwnPassword
      },
      async openAccountSettings(){
        this.showDrawer = true;
        var credentials = await HTTPRequest.getRequest(this.endPoint + 'settings/accountSettings?field_name=code' , null)
        this.checkSettings(credentials)
        try {
          this.accountCredentials = JSON.parse(credentials.value)
        } catch (error) {}
        this.enableInventorySnapshot = this.accountCredentials.enableInventorySnapshot == undefined ? false : this.accountCredentials.enableInventorySnapshot
        this.accountCredentials.defaultCurrency==undefined ? this.accountCredentials.defaultCurrency = 0 : this.accountCredentials.defaultCurrency != 0 ? this.getDefaultCurrency() : ""
        this.getCurrencies()
      },
      async saveIntegCredentials(){
        if(this.accountCredentials.onPasswordExpiration!=undefined && this.accountCredentials.onPasswordExpiration){
          if(this.accountCredentials.passExpDuration == null || this.accountCredentials.passExpDuration == undefined){
            this.$notification['error']({
              message: 'Error',
              description: "password Expiration Duration is a required field."
            });
            return "error"
          }
        }
        if(this.accountCredentials.documentCostingMethod !== undefined){
          var settingPayload = { setting: 
                               {code: "accountSettings", name: "Account Settings", value: JSON.stringify(this.accountCredentials), status: 'A'},
                         }
        var credentials = await HTTPRequest.postRequest(this.endPoint + 'settings', null, settingPayload)
        if(this.accountCredentials.onPasswordExpiration != undefined){
          if(this.accountCredentials.onPasswordExpiration || this.accountCredentialsCopy.onPasswordExpiration){
            var post_req = await HTTPRequest.postRequest(this.endPoint + 'settings/update_user_password_expiration', null, {pass_exp_setting:this.accountCredentials.onPasswordExpiration,duration:this.accountCredentials.passExpDuration})
          }
        }
        this.showDrawer = false;
        this.$notification['success']({
            message: 'Success',
            description: "You have succesfully updated account settings."
        });
        this.errors=[]
        }else{
          // bryan
          this.$notification['error']({
            message: 'Error',
            description: "Costing Method is a required field."
        });
        }
      },
      async getSites(){
        var sites = await HTTPRequest.getRequest(this.endPoint + '/users/' + secureStorage.getItem("userId")  + '/valid_sites', null, null)
        this.updateValidSites(sites)
      },
      async getCurrencies(){
        var currencies = await HTTPRequest.getRequest(this.endPoint + '/currencies?without_php='+true, null, null)
        if (currencies["error"] == undefined){
          this.currenciesOptions = currencies["data"]
        }else{
          this.$notification['error']({
            message: 'Failed',
            description: currencies["error"]
          });
        }
      },
      async getDefaultCurrency(){
        var default_currency = await HTTPRequest.getRequest(this.endPoint + 'currencies/'+this.accountCredentials.defaultCurrency, null)
        if(default_currency["error"] == undefined){
          (default_currency["status"]!="A") ? this.accountCredentials.defaultCurrency = 0 : ""
        }else{
          this.notifMessage = default_currency["error"].split(",");
        }
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      ...mapActions(['updateLoggedInStatus', 'updateValidSites']),
      async revokeToken() {
        let request = await HTTPRequest.postRequest(this.endPoint.split("/api")[0] + '/oauth/revoke', null, { token: secureStorage.getItem("accessToken") })
        if (request["error"] == undefined) {
          secureStorage.removeItem("accessToken");
          secureStorage.removeItem("refreshToken");
        } else {
          console.log(request["error"])
        }
      },
      async logout(){
        if (this.developerMode == true){
          secureStorage.setItem("developerMode", false);
          secureStorage.setItem("userName", null);
          secureStorage.setItem("developerEmail", null);
          this.$router.push('/developer');

          var id = secureStorage.getItem("sessionId")
          axios({
            method: 'delete',
            url: this.endPoint + '/backend_sessions/' + id,
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
              "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
            },
          })
          .then(() => console.log("Session successfully deleted"))
          .catch(error => {
              console.log(error)
              console.log("Forcing session clear");
              this.clearExistingSession()
          })
          .finally(function () {
            component_x.updateLoggedInStatus(false);
            secureStorage.setItem("loggedIn", false)
            navigate.push('/developer');
            component_x.revokeToken()
          })
        }else{
        // Destroy Session
          var id = secureStorage.getItem("sessionId")
          axios({
            method: 'delete',
            url: this.endPoint + '/backend_sessions/' + id,
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
              "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
            },
          })
          .then(() => console.log("Session successfully deleted"))
          .catch(error => {
            console.log(error)
            console.log("Forcing session clear");
            this.clearExistingSession()
          })
          .finally(function () {
            component_x.updateLoggedInStatus(false);
            secureStorage.setItem("loggedIn", false)
            secureStorage.removeItem("userName");
            secureStorage.removeItem("email");
            navigate.push('/');
            component_x.revokeToken()
          })
        }
      },
      testing(){
        console.log(this.accountCredentials.defaultCurrency)
      },
      async clearExistingSession(){
        const username = secureStorage.getItem("email")
        const is_developer = secureStorage.getItem("developerMode")
        var post_request = await HTTPRequest.postRequest(this.endPoint + 'backend_sessions/delete_existing_session?email=' + username + '&account=' + this.accountName + '&is_developer=' + is_developer, null, null)
        
        if (post_request.status == true) {
          console.log("Session successfully cleared")
        } else {
          console.log("Error clearing existing session");
        }
      },
    }
  };
</script>

<style lang='scss'>
</style>

<style scoped>
</style>
